import img20a from '../../../assets/gallery/20a/20a-01-HOME_a.jpg';
import img20b from '../../../assets/gallery/20a/20a-02.jpg';
import img20c from '../../../assets/gallery/20a/20a-03.jpg';
import img20d from '../../../assets/gallery/20a/20a-04.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "",
    pictureSrc: img20a,
    description: "2020",
    orientation: "h"
  },
  {
    id: 2,
    title: "",
    dimensions: "",
    pictureSrc: img20b,
    description: "2020",
    orientation: "h"
  },
  {
    id: 3,
    title: "",
    dimensions: "",
    pictureSrc: img20c,
    description: "2020",
    orientation: "h"
  },
  {
    id: 4,
    title: "",
    dimensions: "",
    pictureSrc: img20d,
    description: "2020",
    orientation: "h"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/20a/data20a.js